import { useEffect, useMemo } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import {
  type A7OPCVMClientPortfolio,
  getClientPortfoliosColumns,
} from "./columns";
import {
  type FilterA7OPCVMClientPortfoliosSchema,
  FilterA7OPCVMClientPortfolios,
} from "./filter";

import { Table } from "@/pages/a7/Table";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_client_portfolios";

export const A7OPCVMClientPortfoliosTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(
    () => getClientPortfoliosColumns(t),
    [t, i18n.language],
  );

  useEffect(() => {
    setDocumentTitle(
      t("a7_opcvm_client_portfolios.title", {
        ns: "tables",
        defaultValue: "OPCVM Portfolios",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Table<A7OPCVMClientPortfolio, FilterA7OPCVMClientPortfoliosSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Portfolios",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMClientPortfolios table_name={table_name} />}
      client="a7"
    />
  );
};
